import { render, staticRenderFns } from "./Fkinput.vue?vue&type=template&id=3a511d2c&scoped=true"
import script from "./Fkinput.vue?vue&type=script&lang=js"
export * from "./Fkinput.vue?vue&type=script&lang=js"
import style0 from "./Fkinput.vue?vue&type=style&index=0&id=3a511d2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a511d2c",
  null
  
)

export default component.exports